import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { IRootState } from 'app/shared/reducers';

interface IOwnProps extends RouteProps {
  hasAnyAuthorities?: string[];
}

export interface IPublicRouteProps extends IOwnProps, StateProps {}

export const PublicRouteComponent = ({
  component: Component,
  isAuthenticated,
  ...rest
}: IPublicRouteProps) => {

  const renderRedirect = props => {
      return !isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/contracts',
          }}
        />
      );
  };

  if (!Component) throw new Error(`A component needs to be specified for public route for path ${(rest as any).path}`);

  return <Route {...rest} render={renderRedirect} />;
};


const mapStateToProps = (
  { authentication: { isAuthenticated, account } }: IRootState
) => ({
  isAuthenticated
});

type StateProps = ReturnType<typeof mapStateToProps>;

/**
 * A route wrapped in an authentication check so that routing happens only when you are authenticated.
 * Accepts same props as React router Route.
 * The route also checks for authorization if hasAnyAuthorities is specified.
 */
export const PrivateRoute = connect(mapStateToProps, null, null, { pure: false })(PublicRouteComponent);

export default PrivateRoute;
